import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { WidgetLayout } from '../shared/WidgetLayout/WidgetLayout';
import { Box, Badge } from '@wix/design-system';
import s from './VisualDisplayWidget.module.scss';
import { WidgetButton } from '../shared/WidgetButton/WidgetButton';
import cn from 'classnames';
import { WithMarkdown } from '../shared/WithMarkdown/WithMarkdown';
import { Picture } from '../shared/Picture/Picture';
import { useDisabledWidget } from '../../../shared/disabled-widget/useDisabledWidget';
import { WithDisabledControl } from '../../../shared/disabled-widget/WithDisabledControl';
export const VisualDisplayWidget = _ref => {
  var _data$picture, _firstCard$picture, _firstCard$badge, _firstCard$sections;
  let {
    data,
    context,
    config
  } = _ref;
  const {
    areControlsDisabled,
    enableControls
  } = useDisabledWidget(config);
  const {
    text,
    options = [],
    primaryButton,
    secondaryButton,
    footerButtonsAsColumn,
    bottomText
  } = data;
  const handleButtonClick = function (action, label) {
    if (label === void 0) {
      label = '';
    }
    const handler = effects => {
      const onWidgetActionData = {
        action,
        value: {
          label,
          effects
        }
      };
      context.onWidgetAction(VISUAL_DISPLAY_WIDGET, onWidgetActionData, data.text);
    };
    return handler;
  };
  const firstCard = {
    picture: (_data$picture = data.picture) != null && _data$picture.url ? data.picture : {
      url: data == null ? void 0 : data.image
    },
    badge: data.badge,
    sections: data.sections,
    borderless: data.borderless
  };
  const withFirstCard = ((_firstCard$picture = firstCard.picture) == null ? void 0 : _firstCard$picture.url) || ((_firstCard$badge = firstCard.badge) == null ? void 0 : _firstCard$badge.text) || ((_firstCard$sections = firstCard.sections) == null ? void 0 : _firstCard$sections.length);
  const cards = withFirstCard ? [firstCard, ...options] : options;
  const cardsElements = cards.map((card, index) => {
    var _card$picture, _card$badge, _card$badge2, _card$badge3, _card$sections, _card$secondaryButton, _card$secondaryButton2, _card$primaryButton, _card$primaryButton2;
    if (!card) {
      return null;
    }
    const sectionElements = /*#__PURE__*/React.createElement(Box, {
      className: s.sections
    }, ((card == null ? void 0 : card.sections) || []).map((_ref2, i) => {
      let {
        title,
        subtitle,
        textButton
      } = _ref2;
      return /*#__PURE__*/React.createElement("div", {
        key: i,
        className: s.section
      }, title && /*#__PURE__*/React.createElement("div", {
        className: s.title
      }, /*#__PURE__*/React.createElement(WithMarkdown, null, title)), subtitle && /*#__PURE__*/React.createElement("div", {
        className: s.subtitle
      }, /*#__PURE__*/React.createElement(WithMarkdown, null, subtitle)), (textButton == null ? void 0 : textButton.label) && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(WithDisabledControl, {
        isDisabled: areControlsDisabled,
        onEnable: enableControls,
        t: context.t
      }, /*#__PURE__*/React.createElement(WidgetButton, {
        type: "textButton",
        context: context,
        webAction: textButton.webAction,
        respondText: textButton.respondText,
        icon: textButton.icon,
        sideEffect: textButton.sideEffect,
        onClick: handleButtonClick('option_button_click', textButton.label),
        skin: textButton.skin,
        disabled: areControlsDisabled
      }, textButton.label))));
    }));
    return /*#__PURE__*/React.createElement(Box, {
      direction: "vertical",
      className: cn(s.content, {
        [s.contentBorderless]: card.borderless
      }),
      key: index
    }, ((_card$picture = card.picture) == null ? void 0 : _card$picture.url) && /*#__PURE__*/React.createElement(Picture, _extends({}, card.picture, {
      aspectRatio: "3/2"
    })), (card == null || (_card$badge = card.badge) == null ? void 0 : _card$badge.text) && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Badge, {
      skin: (card == null || (_card$badge2 = card.badge) == null ? void 0 : _card$badge2.skin) || 'neutralStandard',
      type: card == null || (_card$badge3 = card.badge) == null ? void 0 : _card$badge3.type,
      size: "tiny"
    }, card == null ? void 0 : card.badge.text)), !!(card != null && (_card$sections = card.sections) != null && _card$sections.length) && sectionElements, ((card == null ? void 0 : card.secondaryButton) || (card == null ? void 0 : card.primaryButton)) && /*#__PURE__*/React.createElement(Box, {
      direction: "horizontal",
      align: "space-between",
      verticalAlign: "middle",
      className: s.optionButtons
    }, (card == null || (_card$secondaryButton = card.secondaryButton) == null ? void 0 : _card$secondaryButton.label) && /*#__PURE__*/React.createElement(WithDisabledControl, {
      isDisabled: areControlsDisabled,
      onEnable: enableControls,
      t: context.t
    }, /*#__PURE__*/React.createElement(WidgetButton, {
      type: "textButton",
      context: context,
      webAction: card == null ? void 0 : card.secondaryButton.webAction,
      respondText: card == null ? void 0 : card.secondaryButton.respondText,
      icon: card == null ? void 0 : card.secondaryButton.icon,
      sideEffect: card == null ? void 0 : card.secondaryButton.sideEffect,
      onClick: handleButtonClick('option_button_click', card == null || (_card$secondaryButton2 = card.secondaryButton) == null ? void 0 : _card$secondaryButton2.label),
      skin: "standard",
      disabled: areControlsDisabled
    }, card == null ? void 0 : card.secondaryButton.label)), (card == null || (_card$primaryButton = card.primaryButton) == null ? void 0 : _card$primaryButton.label) && /*#__PURE__*/React.createElement(WithDisabledControl, {
      isDisabled: areControlsDisabled,
      onEnable: enableControls,
      t: context.t
    }, /*#__PURE__*/React.createElement(WidgetButton, {
      context: context,
      webAction: card == null ? void 0 : card.primaryButton.webAction,
      respondText: card == null ? void 0 : card.primaryButton.respondText,
      icon: card == null ? void 0 : card.primaryButton.icon,
      sideEffect: card == null ? void 0 : card.primaryButton.sideEffect,
      onClick: handleButtonClick('option_button_click', card == null || (_card$primaryButton2 = card.primaryButton) == null ? void 0 : _card$primaryButton2.label),
      skin: "standard",
      priority: "secondary",
      disabled: areControlsDisabled
    }, card == null ? void 0 : card.primaryButton.label))));
  });
  return /*#__PURE__*/React.createElement(WidgetLayout, {
    text: text,
    secondaryButton: secondaryButton,
    primaryButton: primaryButton,
    context: context,
    onSecondaryButtonClick: handleButtonClick('secondary_button_click', secondaryButton == null ? void 0 : secondaryButton.label),
    onPrimaryButtonClick: handleButtonClick('primary_button_click', primaryButton == null ? void 0 : primaryButton.label),
    footerButtonsAsColumn: footerButtonsAsColumn,
    bottomText: bottomText,
    disabled: areControlsDisabled,
    onEnableControls: enableControls
  }, cardsElements);
};
export const VISUAL_DISPLAY_WIDGET = 'VISUAL_DISPLAY_WIDGET';
//# sourceMappingURL=VisualDisplayWidget.js.map